import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="font-heading text-2xl font-bold text-foreground-950">漫境</span>
          <span className="hidden sm:inline text-xs text-foreground-500 tracking-widest uppercase mt-1">
            Manga Realm
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            首页
          </Link>
          <Link
            to="/category/xuan-yi-jing-song"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname.startsWith('/category')
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            分类浏览
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname === '/about'
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/category/xuan-yi-jing-song"
            className="px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 cursor-pointer">
              首页
            </Link>
            <Link to="/category/xuan-yi-jing-song" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 cursor-pointer">
              分类浏览
            </Link>
            <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 cursor-pointer">
              关于我们
            </Link>
            <Link
              to="/category/xuan-yi-jing-song"
              className="mt-2 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}